module.exports = __webpack_public_path__ + "img/error.48ca7531.png";